import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import style from "./VarifyCode.module.scss";
import Toast from "../../../Toast/Toast"
import toEnglishNumber from "../../../../helpers/actions/toEnglishNumber";
import toPersianNumber from "../../../../helpers/actions/toPersianNumber";
import Button from '../../../Button/button';
import { forgetPassword, VerifyCode } from "../../../../actions/APIcalls";
import Cookies from "js-cookie";

const VarifyCode = (props) => {
    const [counter, setCounter] = useState(120);
    const [showToast, setShowToast] = useState({ show: false, text: "" })
    const [codeError, setCodeError] = useState({ text: '' })
    const [loading, setLoading] = useState(false);
    const closeToast = () => {
        setShowToast({ show: false, text: '' });
    }

    const sendCode = async () => {
        let params = {
            phone: props.location.state.tel
        }
        const res = await forgetPassword(params)
        if (typeof res !== "undefined" && res.data.success) {
            setCounter(120)
        } else {
            // console.log("show tost salim")
            if (typeof res.response !== "undefined") {
                setShowToast({ show: true, text: res.response.data.error })
            }
        }
    }

    const verfiyCode = async (code) => {
        if (code.length == 5) {
            let params = {
                validationCode: code,
                phone: toEnglishNumber(props.location.state.tel),
            }
            setLoading(true);
            let res = await VerifyCode(params)
            if (typeof res !== "undefined") {
                if (typeof res.data !== "undefined") {
                    Cookies.set("token", res.data.token, { expires: 30 });
                    props.history.push({
                        pathname: '/signin/newpassword',
                        state: {
                            code: code,
                            phone: toEnglishNumber(props.location.state.tel)
                        }
                    });
                    setLoading(false)
                } else {
                    if (typeof res.response !== "undefined") {
                        setCodeError({ text: res.response.data.error })
                    }
                    setLoading(false)
                }
            }
        } else {
            setCodeError({ text: "کد تایید را وارد کنید" })
            setLoading(false)
        }
    }


    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
        // if (counter === 0) {
        //   // sendCode();
        //   // setCounter(120);
        // }
    }, [counter]);

    // validation
    let nameInput = ['', '', '', '', '']
    const [code, setCode] = useState([])
    ///lifecycles **********************************************************************************************************
    useEffect(() => {
        if (typeof (props.location.state) !== "undefined") {
            nameInput[0].focus();
        } else {
            props.history.push("/signin/main")
        }
    }, [])

    useEffect(() => {
        if (code.length === 5) {
            verfiyCode(code.join(''))
        }
    }, [code])

    //functions*****************************************************************************************************************
    const returnSecond = (second) => {
        let newSecond = second % 60;
        if (newSecond.toString().length === 1) {
            return "0" + newSecond
        } else {
            return newSecond;
        }
    }

    const returnMinute = (min) => {
        let newMinute = min / 60
        if (Math.floor(newMinute).toString().length === 1) {
            return "0" + Math.floor(newMinute)
        } else {
            return Math.floor(newMinute);
        }
    }
    const handleCode = (num, e) => {
        let tmpCode = code;
        let tmpNumber = Number(num);
        if (e.target.value !== '') {
            tmpCode[num] = e.target.value;
            setCode([...tmpCode])
            tmpNumber++
            if (tmpNumber < 5) {
                nameInput[tmpNumber].focus();
            }
        }
    }
    const handleBackSpace = (inputNumber) => {
        let Code = code;
        Code[inputNumber] = ''
        setCode([...Code]);
        inputNumber--;
        if (inputNumber >= 0) {
            nameInput[inputNumber].focus();
        }
    }


    return (
        <React.Fragment>
            <div className={style.signUpStepTwo}>
                <Toast
                    tag='repeatedNumber'
                    value={showToast.show}
                    text={showToast.text}
                    parentClose={closeToast}
                />
                {/* <p className={style.signinLinkText}>حساب‌کاربری ندارید؟<span><Link
                    to='/signup/stepone'>ثبت‌نام</Link></span></p> */}
                <div className={style.verifyBoxFrame}>
                    <h3>بازیابی رمز عبور</h3>
                    <div className={style.formWrapper}>
                        {
                            typeof props.location.state !== 'undefined' ?
                                <p className={style.phoneNumber}>{toPersianNumber(props.location.state.tel)}</p>
                                : <p className={style.phoneNumber}></p>
                        }
                        < p className={style.explaination}>لطفا کد تایید ارسال شده به شماره موبایل خود را وارد کنید.</p>

                        <div className={style.inputFrame}>
                            <input maxLength={1} onChange={e => handleCode(0, e)} value={toPersianNumber(code[0])}
                                ref={(input) => {
                                    nameInput[0] = input;
                                }}
                                onKeyDown={(event) => event.key === "Backspace" ? handleBackSpace(0) : null}></input>
                            <input maxLength={1} onChange={e => handleCode(1, e)} value={toPersianNumber(code[1])}
                                ref={(input) => {
                                    nameInput[1] = input;
                                }}
                                onKeyDown={(event) => event.key === "Backspace" ? handleBackSpace(1) : null}></input>
                            <input maxLength={1} onChange={e => handleCode(2, e)} value={toPersianNumber(code[2])}
                                ref={(input) => {
                                    nameInput[2] = input;
                                }}
                                onKeyDown={(event) => event.key === "Backspace" ? handleBackSpace(2) : null}></input>
                            <input maxLength={1} onChange={e => handleCode(3, e)} value={toPersianNumber(code[3])}
                                ref={(input) => {
                                    nameInput[3] = input;
                                }}
                                onKeyDown={(event) => event.key === "Backspace" ? handleBackSpace(3) : null}></input>
                            <input style={{ margin: "0px" }} maxLength={1} onChange={e => handleCode(4, e)}
                                value={toPersianNumber(code[4])} ref={(input) => {
                                    nameInput[4] = input;
                                }}
                                onKeyDown={(event) => event.key === "Backspace" ? handleBackSpace(4) : null}
                            ></input>

                            {/*hidden input to prevent autofill*/}
                            <input style={{ margin: "0px", display: 'none' }} maxLength={1} onChange={e => handleCode(5, e)}
                                value={toPersianNumber(code[5])} ref={(input) => {
                                    nameInput[5] = input;
                                }}
                                onKeyDown={(event) => event.key === "Backspace" ? handleBackSpace(5) : null}
                            ></input>
                            {/*hidden input to prevent autofill*/}
                        </div>
                        {codeError.text && <p className={style.error}>{codeError.text}</p>}

                        <div className={style.resendContainer}>
                            <div
                                onClick={counter === 0 ? sendCode : null}
                                className={counter === 0 ? style.resendActive : style.resend}>
                                ارسال مجدد کد
                                {counter === 0 ? null :
                                    <span>({toPersianNumber(returnMinute(counter))}:{toPersianNumber(returnSecond(counter))})</span>}</div>
                            <div className={style.editPhoneNumber}>
                                <div onClick={() => props.history.push("/signin/phone")}>
                                    ویرایش شماره موبایل
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={style.confirmButton}>
                        <Button
                            loading={loading}
                            disabled={false}
                            tag="register"
                            type="solid"
                            label="تایید"
                            onclick={() => verfiyCode(code.join(''))}
                        />
                        <p className={style.registerLink}>حساب‌کاربری ندارید؟
                            <span className={style.link}>
                                <Link
                                    to='/signup/stepone'>ثبت‌نام در موبیشا</Link>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(VarifyCode);